"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var FormField_1 = __importDefault(require("../FormField"));
var Label_1 = __importDefault(require("../Label"));
var Box_1 = __importDefault(require("../Box"));
var FieldError_1 = __importStar(require("../FieldError"));
var StyledBox = styled_components_1["default"](Box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var withError = function (FieldComponent) {
    var StyledField = styled_components_1["default"](FieldComponent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), FieldError_1.error);
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var _a = this.props, id = _a.id, label = _a.label, icon = _a.icon, input = _a.input, meta = _a.meta, pt = _a.pt, mr = _a.mr, ml = _a.ml, errorMessage = _a.errorMessage, showInitialError = _a.showInitialError, rest = __rest(_a, ["id", "label", "icon", "input", "meta", "pt", "mr", "ml", "errorMessage", "showInitialError"]);
            var hasError = Boolean(errorMessage) ||
                Boolean((meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) &&
                    !meta.submitting);
            var showError = showInitialError
                ? hasError
                : Boolean(meta.touched && hasError);
            var errorValue = errorMessage || meta.error || meta.submitError;
            return (react_1["default"].createElement(StyledBox, { pt: pt, mr: mr, ml: ml },
                react_1["default"].createElement(FormField_1["default"], null,
                    typeof label === 'object' ? label : null,
                    typeof label === 'string' ? react_1["default"].createElement(Label_1["default"], null, label) : null,
                    react_1["default"].createElement(StyledField, __assign({}, input, { error: showError, id: id }, rest)),
                    icon || null),
                showError ? (react_1["default"].createElement(FieldError_1["default"], { id: id + "Error", "aria-describedby": id }, errorValue.id ? (react_1["default"].createElement(react_intl_1.FormattedMessage, { id: errorValue.id, values: __assign({}, errorValue.values) })) : (errorValue))) : null));
        };
        return class_1;
    }(react_1.PureComponent));
};
exports["default"] = withError;
var templateObject_1, templateObject_2;
//# sourceMappingURL=withError.js.map